import { c as _c } from "react/compiler-runtime";
// «Мои заказы» по макету «Профиль» (кадр 5): сегменты «Актуальные заказы |
// Завершенные» — у выбранного полная подпись, у второго короткая («Актуальные |
// Завершенные заказы» в кадре 3956:117714); карточки заказов 810×130 белые r20
// (p12/16/20/16, строки через 12): статус 16/20 w600 цветом, дата 14/18 #000
// 50 %, сумма 16/20 w600 справа; миниатюры 50×66 r4 через 4 с размером 12/16 на
// белой вуали 36 % в правом нижнем углу; «Оставить отзыв» 32 r8 (#989AA2 12 %,
// 12/16 w600).

import { Skeleton } from "@osmix/ui/skeleton";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Link, useNavigate } from "react-router";
import { api, type Order } from "@/api";
import { ErrorState } from "@/components/common/states";
import { Button } from "@/components/ui/button";
import { OrderActions } from "@/components/profile/order-actions";
import { canBuyerCancel, canBuyerConfirmReceipt } from "@/components/profile/order-cancel";
import { isIndividualOrder, isOrderFinished, orderNumber, orderStatusColor, orderStatusLabel, shortDate } from "@/components/profile/order-view";
import { isSellerPickupGroup } from "@/components/orders/seller-pickup-card";
import { ProfilePanel, ProfileSegments } from "@/components/profile/profile-shell";
import { useFormatPrice } from "@/lib/use-format-price";
import { useProfile } from "@/store";
import { type FinishedSort, FinishedToolbar, PurchasesView } from "./purchases";
type Tab = "active" | "finished";
const REVIEWABLE: ReadonlySet<Order["status"]> = new Set(["delivered", "completed", "return_requested", "dispute_open"]);
export function ProfileOrdersPage() {
  const $ = _c(26);
  const userId = useProfile(_temp);
  const [tab, setTab] = useState("active");
  const [showItemsOn, setShowItemsOn] = useState(true);
  const [sort, setSort] = useState("new");
  let t0;
  if ($[0] !== userId) {
    t0 = {
      queryKey: ["buyer", userId, "orders"],
      queryFn: _temp2
    };
    $[0] = userId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const orders = useQuery(t0);
  let t1;
  if ($[2] !== orders || $[3] !== showItemsOn || $[4] !== sort || $[5] !== tab) {
    let t2;
    if ($[7] !== tab) {
      t2 = o => tab === "finished" ? isOrderFinished(o) : !isOrderFinished(o);
      $[7] = tab;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    let t3;
    if ($[9] !== sort || $[10] !== tab) {
      t3 = (a, b) => {
        if (tab !== "finished") {
          return 0;
        }
        const d = Date.parse(b.createdAt) - Date.parse(a.createdAt);
        return sort === "new" ? d : -d;
      };
      $[9] = sort;
      $[10] = tab;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    const list = (orders.data ?? []).filter(t2).sort(t3);
    const showItems = tab === "finished" && showItemsOn;
    const t4 = tab === "active" ? "\u0410\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0435 \u0437\u0430\u043A\u0430\u0437\u044B" : "\u0410\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0435";
    let t5;
    if ($[12] !== t4) {
      t5 = {
        value: "active",
        label: t4
      };
      $[12] = t4;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    const t6 = tab === "finished" ? "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044B\u0435 \u0437\u0430\u043A\u0430\u0437\u044B" : "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044B\u0435";
    let t7;
    if ($[14] !== t6) {
      t7 = {
        value: "finished",
        label: t6
      };
      $[14] = t6;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    let t8;
    if ($[16] !== t5 || $[17] !== t7) {
      t8 = [t5, t7];
      $[16] = t5;
      $[17] = t7;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    let t9;
    if ($[19] !== t8 || $[20] !== tab) {
      t9 = <ProfileSegments value={tab} onChange={setTab} options={t8} />;
      $[19] = t8;
      $[20] = tab;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    let t10;
    if ($[22] !== showItemsOn || $[23] !== sort || $[24] !== tab) {
      t10 = tab === "finished" && !showItemsOn && <div className="mb-4"><FinishedToolbar showItems={false} onShowItemsChange={setShowItemsOn} sort={sort} onSortChange={setSort} /></div>;
      $[22] = showItemsOn;
      $[23] = sort;
      $[24] = tab;
      $[25] = t10;
    } else {
      t10 = $[25];
    }
    t1 = <ProfilePanel title={"\u041C\u043E\u0438 \u0437\u0430\u043A\u0430\u0437\u044B"}>{t9}{t10}{showItems ? <PurchasesView onShowItemsChange={setShowItemsOn} sort={sort} onSortChange={setSort} /> : orders.isPending ? <div className="flex flex-col gap-2.5">{[0, 1, 2].map(_temp3)}</div> : orders.isError ? <ErrorState onRetry={() => void orders.refetch()} /> : list.length === 0 ? <div className="flex flex-col items-center gap-3 rounded-[20px] bg-white px-6 py-14 text-center"><p className="text-[16px] font-medium text-[#161616]">{tab === "finished" ? "\u0417\u0430\u0432\u0435\u0440\u0448\u0451\u043D\u043D\u044B\u0445 \u0437\u0430\u043A\u0430\u0437\u043E\u0432 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442" : "\u0410\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0445 \u0437\u0430\u043A\u0430\u0437\u043E\u0432 \u043D\u0435\u0442"}</p><Button variant="gray" size="sm" asChild={true}><Link to="/catalog">Перейти в каталог</Link></Button></div> : <div className="flex flex-col gap-2.5">{list.map(_temp4)}</div>}</ProfilePanel>;
    $[2] = orders;
    $[3] = showItemsOn;
    $[4] = sort;
    $[5] = tab;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}
function _temp4(order) {
  return <OrderRow key={order.id} order={order} />;
}
function _temp3(i) {
  return <Skeleton key={i} className="h-[130px] rounded-[20px] bg-white" />;
}
function _temp2() {
  return api.buyer.listOrders();
}
function _temp(s) {
  return s.user?.id ?? "guest";
}
function OrderRow(t0) {
  const $ = _c(72);
  const {
    order
  } = t0;
  const fmt = useFormatPrice();
  const navigate = useNavigate();
  let canReview;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== fmt || $[1] !== navigate || $[2] !== order) {
    const items = order.groups.flatMap(_temp5);
    let t10;
    if ($[13] !== navigate || $[14] !== order.id) {
      t10 = () => navigate(`/profile/orders/${encodeURIComponent(order.id)}`);
      $[13] = navigate;
      $[14] = order.id;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    const open = t10;
    let t11;
    if ($[16] !== order.review || $[17] !== order.status) {
      t11 = REVIEWABLE.has(order.status) && !order.review;
      $[16] = order.review;
      $[17] = order.status;
      $[18] = t11;
    } else {
      t11 = $[18];
    }
    canReview = t11;
    t3 = "link";
    t4 = 0;
    t5 = open;
    if ($[19] !== open) {
      t6 = e => {
        if (e.key === "Enter") {
          open();
        }
      };
      $[19] = open;
      $[20] = t6;
    } else {
      t6 = $[20];
    }
    t7 = "flex cursor-pointer flex-col gap-3 rounded-[20px] bg-white px-4 pt-3 pb-5 outline-none transition-shadow hover:shadow-[0_2px_12px_rgba(0,0,0,0.06)] focus-visible:ring-2 focus-visible:ring-[#1F1F1F]/40";
    let t12;
    if ($[21] !== order.status) {
      t12 = orderStatusColor(order.status);
      $[21] = order.status;
      $[22] = t12;
    } else {
      t12 = $[22];
    }
    let t13;
    if ($[23] !== t12) {
      t13 = {
        color: t12
      };
      $[23] = t12;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    let t14;
    if ($[25] !== order.status) {
      t14 = orderStatusLabel(order.status);
      $[25] = order.status;
      $[26] = t14;
    } else {
      t14 = $[26];
    }
    let t15;
    if ($[27] !== t13 || $[28] !== t14) {
      t15 = <span className="whitespace-nowrap text-[16px] leading-5 font-semibold tracking-[-0.31px]" style={t13}>{t14}</span>;
      $[27] = t13;
      $[28] = t14;
      $[29] = t15;
    } else {
      t15 = $[29];
    }
    let t16;
    if ($[30] !== order.createdAt) {
      t16 = shortDate(order.createdAt);
      $[30] = order.createdAt;
      $[31] = t16;
    } else {
      t16 = $[31];
    }
    let t17;
    if ($[32] !== t16) {
      t17 = <span className="whitespace-nowrap text-[14px] leading-[18px] text-black/50">{t16}</span>;
      $[32] = t16;
      $[33] = t17;
    } else {
      t17 = $[33];
    }
    let t18;
    if ($[34] !== order.id || $[35] !== order.number) {
      t18 = orderNumber(order.id, order.number);
      $[34] = order.id;
      $[35] = order.number;
      $[36] = t18;
    } else {
      t18 = $[36];
    }
    let t19;
    if ($[37] !== t18) {
      t19 = <span className="whitespace-nowrap text-[14px] leading-[18px] text-black/50">№{t18}</span>;
      $[37] = t18;
      $[38] = t19;
    } else {
      t19 = $[38];
    }
    let t20;
    if ($[39] !== order) {
      t20 = isIndividualOrder(order) ? <span className="whitespace-nowrap rounded-full bg-[#F2F2F2] px-2 py-0.5 text-[12px] leading-4 font-medium text-[#1F1F1F]" data-testid="order-row-individual">Индивидуальный заказ</span> : null;
      $[39] = order;
      $[40] = t20;
    } else {
      t20 = $[40];
    }
    let t21;
    if ($[41] !== t15 || $[42] !== t17 || $[43] !== t19 || $[44] !== t20) {
      t21 = <p className="flex min-w-0 flex-wrap items-baseline gap-x-2 gap-y-0.5">{t15}{t17}{t19}{t20}</p>;
      $[41] = t15;
      $[42] = t17;
      $[43] = t19;
      $[44] = t20;
      $[45] = t21;
    } else {
      t21 = $[45];
    }
    let t22;
    if ($[46] !== fmt || $[47] !== order.total) {
      t22 = fmt(order.total);
      $[46] = fmt;
      $[47] = order.total;
      $[48] = t22;
    } else {
      t22 = $[48];
    }
    let t23;
    if ($[49] !== t22) {
      t23 = <span className="shrink-0 text-[16px] leading-5 font-semibold tracking-[-0.31px] text-[#1F1F1F]">{t22}</span>;
      $[49] = t22;
      $[50] = t23;
    } else {
      t23 = $[50];
    }
    if ($[51] !== t21 || $[52] !== t23) {
      t8 = <div className="flex items-start justify-between gap-3">{t21}{t23}</div>;
      $[51] = t21;
      $[52] = t23;
      $[53] = t8;
    } else {
      t8 = $[53];
    }
    if ($[54] !== order.groups) {
      t9 = order.groups.filter(isSellerPickupGroup).map(_temp6);
      $[54] = order.groups;
      $[55] = t9;
    } else {
      t9 = $[55];
    }
    t1 = "flex gap-1 overflow-hidden";
    t2 = items.map(_temp7);
    $[0] = fmt;
    $[1] = navigate;
    $[2] = order;
    $[3] = canReview;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    canReview = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
    t9 = $[12];
  }
  let t10;
  if ($[56] !== t1 || $[57] !== t2) {
    t10 = <div className={t1}>{t2}</div>;
    $[56] = t1;
    $[57] = t2;
    $[58] = t10;
  } else {
    t10 = $[58];
  }
  let t11;
  if ($[59] !== canReview || $[60] !== order) {
    t11 = (canReview || canBuyerCancel(order) || canBuyerConfirmReceipt(order)) && <div className="flex flex-wrap items-start gap-2">{canReview && <Button variant="gray" size="sm" asChild={true}><Link to="/profile/reviews" onClick={_temp8}>Оставить отзыв</Link></Button>}<OrderActions order={order} /></div>;
    $[59] = canReview;
    $[60] = order;
    $[61] = t11;
  } else {
    t11 = $[61];
  }
  let t12;
  if ($[62] !== t10 || $[63] !== t11 || $[64] !== t3 || $[65] !== t4 || $[66] !== t5 || $[67] !== t6 || $[68] !== t7 || $[69] !== t8 || $[70] !== t9) {
    t12 = <div role={t3} tabIndex={t4} onClick={t5} onKeyDown={t6} className={t7}>{t8}{t9}{t10}{t11}</div>;
    $[62] = t10;
    $[63] = t11;
    $[64] = t3;
    $[65] = t4;
    $[66] = t5;
    $[67] = t6;
    $[68] = t7;
    $[69] = t8;
    $[70] = t9;
    $[71] = t12;
  } else {
    t12 = $[71];
  }
  return t12;
}

// Миниатюра товара 50×66 r4; размер 12/16 — на белой вуали 36 % (размытие 4,
// скругление слева сверху 2) в правом нижнем углу.
function _temp8(e_0) {
  return e_0.stopPropagation();
}
function _temp7(item, i) {
  return <OrderThumb key={`${item.productId}-${item.variantId ?? item.size}-${i}`} photo={item.photo} name={item.name} size={item.size} />;
}
function _temp6(g_0) {
  return g_0.shipment?.pickupPoint ? <p key={g_0.shopId} className="text-[14px] leading-[18px] text-[#1F1F1F]/72" data-testid="order-row-pickup">Самовывоз: {g_0.shipment.pickupPoint.name}, {[g_0.shipment.pickupPoint.city, g_0.shipment.pickupPoint.address].join(", ")}{g_0.shipment.pickupPoint.schedule ? ` · ${g_0.shipment.pickupPoint.schedule}` : ""}{g_0.sellerPickup?.code && (g_0.sellerPickup.status === "ready" || g_0.sellerPickup.status === "new") ? <span className="ml-1 font-semibold text-[#161616]"> · код {g_0.sellerPickup.code}</span> : null}</p> : null;
}
function _temp5(g) {
  return g.items;
}
export function OrderThumb(t0) {
  const $ = _c(8);
  const {
    photo,
    name,
    size
  } = t0;
  let t1;
  if ($[0] !== name || $[1] !== photo) {
    t1 = photo ? <img src={photo} alt={name} loading="lazy" className="size-full object-cover" /> : null;
    $[0] = name;
    $[1] = photo;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== size) {
    t2 = size ? <span className="absolute right-0 bottom-0 max-w-full truncate rounded-tl-[2px] bg-white/36 px-0.5 text-center text-[12px] leading-4 text-[#1F1F1F] backdrop-blur-[4px]">{size}</span> : null;
    $[3] = size;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <span className="relative block h-[66px] w-[50px] shrink-0 overflow-hidden rounded-[4px] bg-[#F2F2F2]">{t1}{t2}</span>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}